export default {"src":"/_next/static/media/DAL.49fbde8d.svg","height":18,"width":18};